import { Link } from "gatsby";
import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";

const CardSingle = ({ pageBlock, alwaysShowImage, section }) => {
  const linkClass = alwaysShowImage
    ? "block md:flex md:items-center md:group hover:ring"
    : "flex items-center group hover:ring";

  const CardStyles = styled.div`
    ${tw`px-5 py-4 lg:py-0 lg:py-2`}
    p {
      ${tw`text-sm lg:text-base text-gray-800`}
      margin-bottom: 0 !important;
    }
    p:empty {
      display: none !important;
    }
  `;

  return (
    <>
      <li
        key={pageBlock._key}
        className="md:flex my-4 bg-white items-center shadow"
      >
        {pageBlock.link ? (
          pageBlock.link.href ? (
            <a href={pageBlock.link.href} className={linkClass}>
              <div
                className={`${
                  alwaysShowImage ? "" : "hidden "
                }md:block md:flex-shrink-0 md:w-56`}
              >
                {pageBlock.image && pageBlock.image.asset && (
                  <Image
                    {...pageBlock.image}
                    width={224}
                    className="align-top"
                    alt={pageBlock.image.alt || ``}
                  />
                )}
              </div>
              <CardStyles section={section}>
                <h3 className="mb-1 tracking-tight text-blue-500 lg:text-lg font-bold underline group-hover:text-blue-700 lg:leading-tight">
                  {pageBlock.title}
                </h3>
                <div className="text-sm lg:text-base mt-1 text-gray-600">
                  {pageBlock._rawBody && (
                    <BlockText blocks={pageBlock._rawBody} section={section} />
                  )}
                </div>
              </CardStyles>
            </a>
          ) : pageBlock.link &&
            pageBlock.link.reference &&
            pageBlock.link.reference.path ? (
            <a href={pageBlock.link.reference.path} className={linkClass}>
              <div
                className={`${
                  alwaysShowImage ? "" : "hidden "
                }md:block md:flex-shrink-0 md:w-56`}
              >
                {pageBlock.image && pageBlock.image.asset && (
                  <Image
                    {...pageBlock.image}
                    width={224}
                    className="align-top"
                    alt={pageBlock.image.alt || ``}
                  />
                )}
              </div>
              <CardStyles section={section}>
                <h3 className="mb-1 tracking-tight text-blue-500 lg:text-lg font-bold underline group-hover:text-blue-700 lg:leading-tight">
                  {pageBlock.title}
                </h3>
                {pageBlock._rawBody && (
                  <BlockText blocks={pageBlock._rawBody} section={section} />
                )}
              </CardStyles>
            </a>
          ) : (
            <>
              <div
                className={`${
                  alwaysShowImage ? "" : "hidden "
                }md:block md:flex-shrink-0 md:w-56`}
              >
                {pageBlock.image && pageBlock.image.asset && (
                  <Image
                    {...pageBlock.image}
                    width={224}
                    className="align-top"
                    alt={pageBlock.image.alt || ``}
                  />
                )}
              </div>
              <CardStyles section={section}>
                <h3 className="mb-1 text-blue-500 tracking-tight lg:text-lg font-bold lg:leading-tight">
                  {pageBlock.title}
                </h3>
                {pageBlock._rawBody && (
                  <BlockText blocks={pageBlock._rawBody} section={section} />
                )}
              </CardStyles>
            </>
          )
        ) : (
          <>
            <div
              className={`${
                alwaysShowImage ? "" : "hidden "
              }md:block md:flex-shrink-0 md:w-56`}
            >
              {pageBlock.image && pageBlock.image.asset && (
                <Image
                  {...pageBlock.image}
                  width={224}
                  className="align-top"
                  alt={pageBlock.image.alt || ``}
                />
              )}
            </div>
            <CardStyles section={section}>
              <h3 className="mb-1 text-blue-500 lg:text-lg tracking-tight font-bold md:leading-tight">
                {pageBlock.title}
              </h3>
              <div className="text-sm md:text-base text-gray-800">
                {pageBlock._rawBody && (
                  <BlockText blocks={pageBlock._rawBody} section={section} />
                )}
              </div>
            </CardStyles>
          </>
        )}
      </li>
    </>
  );
};

export default CardSingle;
